import React from 'react';

import Icon from './square-icons/video.png';

const SquareVideoIcon = () => {
  return <img style={{ height: 30, width: 30 }} src={Icon} alt="video-icon" />;
};

export default SquareVideoIcon;
